import Icons from "@/assets/icons/icons";

export const Values = {
  // API Constants
  myBookingLimit:5,
  venueListLimit:10,
  getReviewsLimit:5,
  sportsTypeEnum: [

    { name: 'Cricket', url: Icons.cricket ,icon: "🏏"},
    { name: 'Football', url: Icons.football ,icon:"⚽"},
    { name: 'Tennis', url: Icons.tabletennis ,icon: "🎾"},
    { name: 'Table Tennis', url: Icons.tabletennis ,icon: "🏓"},
    { name: 'Pickleball', url: Icons.Pickleball ,icon: null},
    { name: 'Volleyball', url: Icons.Volleyball ,icon: "🏐"},
    { name: 'Badminton', url: Icons.badminton ,icon: "🏸"},
    { name: 'Basketball', url: Icons.basketball,icon:"🏀" },
    { name: 'swimming', url: Icons.swimming ,icon: "🏊"},

    { name: 'Boxing', url: Icons.boxing, icon:"🥊" },
    { name: 'Squash', url: Icons.boxing, icon:"🏀" },

    // "Football",
    // "Cricket",
    // "Pickleball",
    // "Net Cricket",
    // "Badminton",
    // "Tennis",
    // "Basketball",
    // "Volleyball",
    // "Table Tennis",
    // "Squash",
    // "Hockey",
    // "Kabaddi",
    // "Handball",
    // "Boxing",
    // "Skating",
    // "Swimming",
    // "Gymnastics",
    // "Wrestling",
    // "Martial Arts",
    // "Snooker / Pool",
    // "Carrom",
    // "Chess",
    // "Other"
  ],
  API_TIMEOUT: 60,
  PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50],

  // auth keys
  jwtToken: 'JWtToken',
  jwtTokenDBL:"bearer_token_dbl",
  jwtTokenV2:"bearer_token",

  bookingSource : {
        APP: "APP",
        WEB: "WEB",
        DBL: "DBL",
        MARKETPLACE: "MARKETPLACE",
        ALL: "ALL",
        VENDOR: "VENDOR"
    },
  AllRoleTypes: {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    AGENCY_ADMIN: 'AGENCY_ADMIN',
    AGENCY_SUPERVISOR: 'AGENT_SUPERVISOR',
    AGENT: 'AGENT',
  },

  edit: 'EDIT',
  resend_link: 'RESEND LINK',

  regex: {
    nameRegEx: '^[A-Za-z][A-Za-z ]*$',
    emailRegExp: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    numberRegExp: '^[0-9]+$ ',
    dateRegEx_DDMMYYY: '^(\\d{2})-(\\d{2})-(\\d{4})$',
    dateRegEx_YYYYMMDD: '^(\\d{4})-(\\d{2})-(\\d{2})$',
    mobileRegExp: '^[6-9][0-9]{9}$',
    last10NumRegExp: '\\d{10}$',
  },

   bookingstatus :["pending", "confirmed", "cancelled", "failed", "completed"],
    discountType:{
      PERCENT:"PERCENT",
      FLAT:"FLAT"
    }
};
